import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import {
  HandexInstance,
  HanjinInstance,
  KpcInstance,
  LogenInstance,
  LotteInstance,
} from "../instance";
import dayjs from "dayjs";
import { todayState } from "../../stores/dashboard/todayState";
import { isKpcCompany, normalizeKpcDashboardData } from "../../utils/kpc";

// TODO 오늘자 데이터 조회 API
const useGetAmount = () => {
  // NOTE 상태 변수
  const login = useRecoilValue(loginState); // 로그인 전역변수
  const setTodayData = useSetRecoilState(todayState); // 오늘자 데이터 전역변수

  // TODO 인스턴스
  const instances = {
    LOGEN: LogenInstance,
    LOTTE: LotteInstance,
    HANJIN: HanjinInstance,
    HANDEX: HandexInstance,
    KPC: KpcInstance,
  };

  // TODO API body 정보
  const postData = {
    bran_cd: login.branchCode,
    scan_date: dayjs().format("YYYY-MM-DD"),
  };

  // TODO API Mutation
  const mutationFn = () => {
    const instance = instances[login.company];
    if (!instance) {
      throw new Error("Invalid company");
    }
    // KPC 대시보드는 세션 점소를 사용하므로 문서상 scan_date만 전송한다.
    return instance.post(
      "/dashboard",
      isKpcCompany(login.company) ? { scan_date: postData.scan_date } : postData,
    );
  };

  // TODO API 결과
  return useMutation("getAmount", mutationFn, {
    // 성공 시
    onSuccess: (data) => {
      if (data.result === "00" || data.result === "77") {
        // 오늘자 데이터에 저장
        // KPC 응답만 기존 대시보드 공통 필드로 변환한다.
        setTodayData(
          isKpcCompany(login.company)
            ? normalizeKpcDashboardData(data.data)
            : data.data,
        );
      }
    },
    // 실패 시
    onError: (error) => {
      console.log(error);
    },
  });
};

export default useGetAmount;
